import { gql } from "@apollo/client";

export const USER_FRAGMENT = gql`
  fragment User on User {
    id
    firstName
    lastName
    darkmode
    language
    isAdmin
  }
`;

export const CURRENT_USER = gql`
  ${USER_FRAGMENT}
  query GetCurrentUser {
    getCurrentUser {
      ...User
    }
  }
`;

export const GET_USERS = gql`
  ${USER_FRAGMENT}
  query GetUsers($pagination: CursorPaginationInput) {
    getUsers(pagination: $pagination) {
      data {
        ...User
      }
      nextCursor
      hasMore
    }
  }
`;

export const LOGIN_USER = gql`
  ${USER_FRAGMENT}
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      ...User
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation {
    logoutUser {
      success
      message
    }
  }
`;

export const CREATE_USER = gql`
  ${USER_FRAGMENT}
  mutation CreateUser(
    $token: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $organisation: String
  ) {
    createUser(
      token: $token
      password: $password
      firstName: $firstName
      lastName: $lastName
      organisation: $organisation
    ) {
      ...User
    }
  }
`;

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($email: String!) {
    sendRecoveryMail(email: $email) {
      success
      message
    }
  }
`;

export const SEND_REGISTRATION_MAIL = gql`
  mutation sendRegistrationMail($email: String!) {
    sendRegistrationMail(email: $email) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  ${USER_FRAGMENT}
  mutation ResetPassword($password: String!, $token: String!) {
    resetPassword(password: $password, token: $token) {
      ...User
    }
  }
`;

export const TOGGLE_DARKMODE = gql`
  mutation ToggleDarkmode($darkmode: Boolean!) {
    toggleDarkmode(darkmode: $darkmode) {
      id
      darkmode
    }
  }
`;

export const CHANGE_LANGUAGE = gql`
  mutation ChangeLanguage($language: String!) {
    changeLanguage(language: $language) {
      id
      language
    }
  }
`;

export const EDIT_USER = gql`
  ${USER_FRAGMENT}
  mutation EditUser($firstName: String!, $lastName: String!) {
    editUser(firstName: $firstName, lastName: $lastName) {
      ...User
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  ${USER_FRAGMENT}
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      ...User
    }
  }
`;

export const DELETE_USER = gql`
  ${USER_FRAGMENT}
  mutation {
    deleteUser {
      ...User
    }
  }
`;

export const GET_TOP_USERS_BY_PROJECTS = gql`
  query GetTopUsersByProjects($limit: Int = 10) {
    getTopUsersByProjects(limit: $limit) {
      id
      firstName
      lastName
      projectCount
      totalPoles
    }
  }
`;

export const GET_TOTALS_BY_ORGANISATION = gql`
  query GetTotalsByOrganisation {
    getTotalsByOrganisation {
      organisation
      totalUsers
    }
  }
`;

export const GET_TOTALS_BY_LANGUAGE = gql`
  query GetTotalsByLanguage {
    getTotalsByLanguage {
      language
      totalUsers
    }
  }
`;

export const GET_TOTALS_BY_DARKMODE = gql`
  query GetTotalsByDarkmode {
    getTotalsByDarkmode {
      darkmode
      totalUsers
    }
  }
`;
